















import { Component, Emit, Prop, Vue } from 'vue-property-decorator';

@Component
export default class ExecutionTime extends Vue {
  @Prop()
  private label!: string;

  @Prop()
  private time!: string | null;

  @Prop({ required: false, default: false })
  private isReadOnly!: boolean;

  private timeValue: string | null = null;

  private timeMenu: boolean = false;

  private async created(): Promise<void> {
    this.timeValue = this.time;
  }

  @Emit('changedTime')
  private changedTime(time: string | null): void {}
}
